import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=4447cf91&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"
import style0 from "./TestPage.vue?vue&type=style&index=0&id=4447cf91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447cf91",
  null
  
)

export default component.exports